import { useEffect } from 'react';
import { useSceneStore } from '../state/sceneStore';

const isEditableTarget = (target: EventTarget | null): boolean =>
  target instanceof HTMLInputElement
  || target instanceof HTMLTextAreaElement
  || target instanceof HTMLSelectElement
  || (target instanceof HTMLElement && target.isContentEditable);

export const useSensorPoseUndoRedo = (): void => {
  const sensorPoseHistory = useSceneStore((state) => state.sensorPoseHistory);
  const sensorPoseRedoHistory = useSceneStore((state) => state.sensorPoseRedoHistory);
  const undoSensorPose = useSceneStore((state) => state.undoSensorPose);
  const redoSensorPose = useSceneStore((state) => state.redoSensorPose);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (isEditableTarget(event.target)) {
        return;
      }

      const {
        isReadOnly,
        referenceImageAlignMode,
      } = useSceneStore.getState();
      if (isReadOnly || referenceImageAlignMode) {
        return;
      }

      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === 'z') {
        if (sensorPoseRedoHistory.length === 0) {
          return;
        }
        event.preventDefault();
        redoSensorPose();
        return;
      }

      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'z') {
        if (sensorPoseHistory.length === 0) {
          return;
        }
        event.preventDefault();
        undoSensorPose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    sensorPoseHistory.length,
    sensorPoseRedoHistory.length,
    undoSensorPose,
    redoSensorPose,
  ]);
};
